<template>
  <div v-show="active"
    class="nebTab"
  >
    <!-- Tab Content -->
    <slot />
  </div>
</template>

<script>
// @group Layout
// Component for rendering a tab. Must be a child of `NebTabs` towork properly.
export default {
  name: 'nebTab',

  props: {
    // The name of the tab. This will be used to keep track of the active tab in `NebTabs`. This is also the value you
    // would specify to the `initialActiveTab`prop on `NebTabs`
    name: {
      type: String,
      required: true
    },
    // This is the text that will be displayed in the tab header.
    label: {
      type: String,
      required: true
    }
  },

  data: () => ({
    active: false
  })
}
</script>

<style scoped lang="scss"></style>
